import { render } from "./gestioneDocModal.vue?vue&type=template&id=d9da0e52&scoped=true&ts=true"
import script from "./gestioneDocModal.vue?vue&type=script&lang=ts"
export * from "./gestioneDocModal.vue?vue&type=script&lang=ts"

import "./gestioneDocModal.vue?vue&type=style&index=0&id=d9da0e52&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9da0e52"]])

export default __exports__